import Box from '@mui/material/Box'
import Icon from 'components/Icon'

const IconError = ({
  hide,
  children,
}) => {

  if (hide) return children

  return (
    <Box
      sx={{
        display: 'inline-grid',
        placeItems: 'center',
        placeContent: 'center',
        position: 'relative',
      }}
    >
      {children}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          display: 'inline-flex',
          transform: 'translate(50%, 50%)',
        }}
      >
        <Icon
          icon="ItemError"
        />
      </Box>
    </Box>
  )
}

export default IconError